import { forwardRef, Ref } from 'react';
import { IMaskMixin, ReactElementProps } from 'react-imask';
import { IMaskInputProps } from 'react-imask/mixin';

import Input, { InputProps } from 'design-system/components/Input/Input';

interface MaskedInputBaseProps {
  inputRef: Ref<HTMLInputElement>;
  componentProps?: InputProps;
}

const MaskedInputBase = IMaskMixin<HTMLInputElement, MaskedInputBaseProps>(
  ({
    inputRef,
    size,
    componentProps,
    ...props
  }: ReactElementProps<HTMLInputElement> & MaskedInputBaseProps) => (
    <Input {...props} {...componentProps} ref={inputRef} />
  ),
);

export type MaskedInputProps = Omit<
  IMaskInputProps<HTMLInputElement>,
  'inputRef' | 'componentProps' | 'size' | 'ref'
> &
  InputProps;

const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(function MaskedInput(
  props: MaskedInputProps,
  ref,
) {
  return <MaskedInputBase {...props} componentProps={props} inputRef={ref} />;
});

export default MaskedInput;
